import{useRef}from"react";export default(function(a){var b=useRef(!0);b.current&&a(),b.current=!1});